<template>
    <!-- eslint-disable max-len -->
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
    >
        <path d="M16 2C16 1.44772 15.5523 1 15 1C14.4477 1 14 1.44772 14 2V3C14 3.55228 14.4477 4 15 4C15.5523 4 16 3.55228 16 3V2Z" />
        <path d="M19.7071 5.70711L20.7071 4.70711C21.0976 4.31658 21.0976 3.68342 20.7071 3.29289C20.3166 2.90237 19.6834 2.90237 19.2929 3.29289L18.2929 4.29289C17.9024 4.68342 17.9024 5.31658 18.2929 5.70711C18.6834 6.09763 19.3166 6.09763 19.7071 5.70711Z" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.1213 6.87868C18.2929 8.05025 18.2929 9.94975 17.1213 11.1213L6.12132 22.1213C4.94975 23.2929 3.05025 23.2929 1.87868 22.1213C0.707107 20.9497 0.707107 19.0503 1.87868 17.8787L12.8787 6.87868C14.0503 5.70711 15.9497 5.70711 17.1213 6.87868ZM15.7071 8.29289C16.0976 8.68342 16.0976 9.31658 15.7071 9.70711L13 12.4142L11.5858 11L14.2929 8.29289C14.6834 7.90237 15.3166 7.90237 15.7071 8.29289Z" />
        <path d="M20 9C20 8.44772 20.4477 8 21 8H22C22.5523 8 23 8.44772 23 9C23 9.55229 22.5523 10 22 10H21C20.4477 10 20 9.55229 20 9Z" />
        <path d="M18.2929 12.2929C18.6834 11.9024 19.3166 11.9024 19.7071 12.2929L20.7071 13.2929C21.0976 13.6834 21.0976 14.3166 20.7071 14.7071C20.3166 15.0976 19.6834 15.0976 19.2929 14.7071L18.2929 13.7071C17.9024 13.3166 17.9024 12.6834 18.2929 12.2929Z" />
        <path d="M10.7071 3.29289C10.3166 2.90237 9.68342 2.90237 9.29289 3.29289C8.90237 3.68342 8.90237 4.31658 9.29289 4.70711L10.2929 5.70711C10.6834 6.09763 11.3166 6.09763 11.7071 5.70711C12.0976 5.31658 12.0976 4.68342 11.7071 4.29289L10.7071 3.29289Z" />
    </svg>
    <!-- eslint-enable max-len -->
</template>

<script>
export default {
    name: 'MagicWandIcon',
    props: {
        size: {
            type: [Number, String],
            default: 24,
        },
    },
};
</script>
